import React from 'react';
import axios from 'axios';

const DATE = new Date();
const REPLACEMENTS = [
  {
    place: '%s%',
    value: 60
  },
  {
    place: '%m%',
    value: 60
  },
  {
    place: '%h%',
    value: 24
  }/*,
  {
    place: '%d%',
    value: 365
  }*/
];

class App extends React.Component
{
  constructor(props) {
    super(props);

    // DATE.setHours(17);
    // DATE.setMinutes(30);
    // DATE.setSeconds(0);

    this.state = {
      currentDate: '',
      // areClasses: DATE.getDay() === 0? true : false,
      areClasses: false,
      late: false,
      initialized: false
    }
  }

  timerFunction = () => {
    let now = new Date();
    let diff = DATE - now;

    let dateString = '%h%:%m%:%s%';

    if(diff < 0) {
      dateString = `-${dateString}`;
      this.setState({
        late: true
      })
    }

    diff = Math.abs(diff);

    diff = parseInt(diff / 1000);

    REPLACEMENTS.forEach((element) => {
      let _value = diff % element.value;
      let valueToReplace = _value;

      if(_value < 10)
        valueToReplace = `0${_value}`;

      dateString = dateString.replace(element.place,valueToReplace);
      diff = parseInt(diff / element.value);
    });

    dateString = dateString.replace('%y%',diff);

    this.setState({
      currentDate: dateString
    });
  }

  componentDidMount() {
    axios.get('/settings.json')
      .then((response) => {
        let settings = response.data;
        let _areClasses = true;

        settings.exceptions.forEach((element) => {
          if(DATE.getFullYear() === element.year &&
              DATE.getMonth() === element.month &&
              DATE.getDate() === element.date) {

            _areClasses = false;
          }
        });

        if(_areClasses) {
          if(DATE.getDay() !== settings.dayOfWeek)
            _areClasses = false;
        }

        DATE.setHours(settings.endTime.hours);
        DATE.setMinutes(settings.endTime.minutes);
        DATE.setSeconds(settings.endTime.seconds);

        this.setState({
          areClasses: _areClasses,
          initialized: true,
          late: (DATE - new Date()) < 0 ? true : false
        });

        this.timerFunction();

        // ***********************************

        if(/*this.state.areClasses*/_areClasses) {
          this.timer = setInterval(this.timerFunction,1000);
        }
        else {
          this.setState({
            currentDate: 'Nie ma zajęć'
          });
        }
    })
  }

  render() {
    let appBackground = 'uninitialized';

    if(this.state.initialized && !this.state.areClasses)
      appBackground = 'free';
    else if(this.state.initialized && this.state.late)
      appBackground = 'late';
    else if(this.state.initialized)
      appBackground = '';


    return (
      <div className={`app ${appBackground}`}>
        <h1 className={`${appBackground}`}>{this.state.currentDate}</h1>
      </div>
    );
  }
}
export default App;
